var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"summary",style:({background: _vm.$$FormData.theme_color || '#202020'})},[_c('span',[_vm._v(_vm._s(_vm.$$FormData.title || '我的消费积分')+" "),_c('strong',[_vm._v("0")])]),(_vm.$$FormData.show_details !== false)?_c('span',[_vm._v("积分明细 ›")]):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }